import React, { useEffect } from "react";
import "./privacy.css";

export default function TermsOfService() {
  useEffect(() => {
    document.title = "Terms of Service — REQUESTA";
  }, []);

  return (
    <main className="rqpv-wrap" role="main">
      <div className="rqpv-card">
        <header className="rqpv-header">
          <div className="rqpv-title">Terms of Service</div>
          <div className="rqpv-meta">
            <span>Effective Date: September 20, 2025</span>
            <span>Company: REQUESTA LLC (Wyoming, USA)</span>
            <span>Platform: Web (requesta.app)</span>
            <span>Contact: <a className="rqpv-link" href="mailto:support@requesta.app">support@requesta.app</a></span>
          </div>
        </header>


        <section id="tos-acceptance" className="rqpv-section">
          <div className="rqpv-h2">1. Acceptance of Terms</div>
          <div className="rqpv-text">
            By accessing or using Request App ("the App"), you agree to these Terms of Service ("Terms").
            If you do not agree, do not use the App.
          </div>
        </section>

        <section id="tos-eligibility" className="rqpv-section">
          <div className="rqpv-h2">2. Eligibility</div>
          <div className="rqpv-text">
            You must be at least 13 years old to use the App. If you are under 18, you represent
            that you have the consent of a parent or guardian.
          </div>
        </section>

        <section id="tos-accounts" className="rqpv-section">
          <div className="rqpv-h2">3. User Accounts</div>
          <ul className="rqpv-list">
            <li className="rqpv-li">You must provide accurate registration information.</li>
            <li className="rqpv-li">You are responsible for maintaining the confidentiality of your login credentials.</li>
            <li className="rqpv-li">We may suspend or terminate accounts at our sole discretion.</li>
          </ul>
        </section>

        <section id="tos-payments" className="rqpv-section">
          <div className="rqpv-h2">4. Payments</div>
          <ul className="rqpv-list">
            <li className="rqpv-li">Payments are processed securely through Stripe, Apple Pay, and Link.</li>
            <li className="rqpv-li">REQUESTA LLC does not store payment card details.</li>
            <li className="rqpv-li">Refunds and chargebacks are handled in accordance with Stripe and Apple Pay policies.</li>
          </ul>
        </section>

        <section id="tos-content" className="rqpv-section">
          <div className="rqpv-h2">5. User Content</div>
          <ul className="rqpv-list">
            <li className="rqpv-li">Users retain ownership of their content (such as song requests and messages).</li>
            <li className="rqpv-li">By submitting content, you grant REQUESTA LLC a worldwide, non-exclusive license to display and transmit that content solely to operate the App.</li>
          </ul>
        </section>

        <section id="tos-prohibited" className="rqpv-section">
          <div className="rqpv-h2">6. Prohibited Uses</div>
          <div className="rqpv-text">You may not:</div>
          <ul className="rqpv-list">
            <li className="rqpv-li">Use the App for unlawful, fraudulent, or abusive purposes.</li>
            <li className="rqpv-li">Interfere with or disrupt the App's functionality.</li>
            <li className="rqpv-li">Infringe upon the intellectual property or rights of others.</li>
          </ul>
        </section>

        <section id="tos-liability" className="rqpv-section">
          <div className="rqpv-h2">7. Limitation of Liability</div>
          <div className="rqpv-text">
            The App is provided "as is." REQUESTA LLC is not liable for missed requests, technical
            issues, outages, lost profits, or damages arising from use of the App.
          </div>
        </section>

        <section id="tos-termination" className="rqpv-section">
          <div className="rqpv-h2">8. Termination</div>
          <div className="rqpv-text">
            We may suspend or terminate access to the App at any time, without notice, for violations of these Terms.
          </div>
        </section>

        <section id="tos-law" className="rqpv-section">
          <div className="rqpv-h2">9. Governing Law</div>
          <div className="rqpv-text">
            These Terms are governed by the laws of Wyoming, USA. Any disputes will be resolved in Wyoming courts.
          </div>
        </section>

        <section id="tos-changes" className="rqpv-section">
          <div className="rqpv-h2">10. Changes</div>
          <div className="rqpv-text">
            We may update these Terms at any time. Continued use of the App constitutes acceptance of the updated Terms.
          </div>
        </section>

        <section id="tos-sms" className="rqpv-section">
          <div className="rqpv-h2">11. SMS Terms &amp; Conditions</div>
          <ul className="rqpv-list">
            <li className="rqpv-li"><strong>Program Name:</strong> Request App SMS Alerts</li>
            <li className="rqpv-li"><strong>Program Description:</strong> Request App sends transactional SMS alerts to performers related to pending requests, payments, account activity, and other service-related notifications.</li>
            <li className="rqpv-li"><strong>Message Frequency:</strong> Message frequency varies based on account activity and user actions.</li>
            <li className="rqpv-li"><strong>Opt-Out:</strong> Reply STOP to cancel SMS messages at any time.</li>
            <li className="rqpv-li"><strong>Help:</strong> Reply HELP for help. You may also contact support at <a className="rqpv-link" href="mailto:support@requesta.app">support@requesta.app</a>.</li>
            <li className="rqpv-li"><strong>Consent:</strong> By providing your phone number and opting in, you agree to receive SMS messages from Request App related to your account. SMS consent is not a condition of purchase or use of the service.</li>
            <li className="rqpv-li"><strong>Message &amp; Data Rates:</strong> Standard message and data rates may apply.</li>
            <li className="rqpv-li"><strong>Privacy:</strong> See our <a className="rqpv-link" href="/privacy">Privacy Policy</a>. Your phone number and SMS consent are never shared with third parties for marketing purposes.</li>
            <li className="rqpv-li"><strong>Supported Carriers:</strong> Available on all major US carriers including AT&amp;T, Verizon, T-Mobile, and others.</li>
          </ul>
        </section>

        <div className="rqpv-updated">Effective Date: September 20, 2025</div>
      </div>
    </main>
  );
}
